import { completeHexColor } from '@/lib/color/hexColorInput';

function normalizePaletteColor(raw: string): string | null {
  const trimmed = raw.trim();
  if (!trimmed) return null;
  const withHash = trimmed.startsWith('#') ? trimmed : `#${trimmed}`;
  return completeHexColor(withHash) ?? null;
}

/** Brand-kit palette entries may be plain hex strings or legacy `{ color }` objects. */
export function parsePaletteColors(raw: unknown): string[] {
  if (!Array.isArray(raw)) return [];

  const colors: string[] = [];
  for (const entry of raw) {
    if (typeof entry === 'string') {
      const normalized = normalizePaletteColor(entry);
      if (normalized) colors.push(normalized);
      continue;
    }

    if (entry && typeof entry === 'object' && 'color' in entry) {
      const nested = (entry as { color?: unknown }).color;
      if (typeof nested === 'string') {
        const normalized = normalizePaletteColor(nested);
        if (normalized) colors.push(normalized);
      }
    }
  }

  return colors;
}
